import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-hidden-icon',
  templateUrl: './general-hidden.component.html'
})
export class GeneralHiddenComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
